import clsx from "clsx";
import { DOCK_CHROME_GLASS_CLASSES } from "@/components/ui/os-layout/osDockIconTheme";

/** Full-width AniOS strip — matches workspace bar height (h-8). */
export const SALTUS_OS_DEMO_BAR_CLASS = clsx(
  "flex w-full min-w-0 shrink-0 select-none items-center border-b leading-none",
  "h-8 px-2",
  "border-violet-200/70 dark:border-violet-500/20",
  "bg-gradient-to-r from-violet-50/95 via-violet-50/85 to-violet-50/70",
  "dark:from-violet-950/55 dark:via-violet-950/40 dark:to-violet-950/25",
  DOCK_CHROME_GLASS_CLASSES,
);

export const SALTUS_OS_DEMO_BAR_ROW_CLASS =
  "flex w-full min-w-0 items-center gap-1 overflow-hidden";

export const SALTUS_OS_DEMO_BAR_ACTIONS_CLASS =
  "ml-auto flex shrink-0 items-center gap-2";

/** Overrides SelectDropdown default h-10 trigger — must use ! for Tailwind precedence. */
export const SALTUS_OS_DEMO_BAR_SELECT_BUTTON_CLASS =
  "!h-6 !min-h-0 !rounded !border-violet-200/80 !py-0 !pl-1.5 !pr-6 !text-xs !leading-none !shadow-none dark:!border-violet-500/25 !focus:ring-0 !focus:ring-offset-0 focus-visible:!ring-0";

export const SALTUS_OS_DEMO_BAR_SELECT_WRAPPER_CLASS =
  "min-w-0 max-w-[18rem] flex-1 shrink [&>div]:!min-w-0 [&>div]:!flex-1 [&>div]:!shrink [&_button]:!min-w-0 [&_button_span]:!min-w-0 [&_button_svg]:!size-3";

export const SALTUS_OS_DEMO_BAR_BUTTON_CLASS =
  "!h-6 !min-h-0 !rounded !px-1.5 !text-xs !leading-none";
